var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderSignInViewLogOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 2.33337H3.33333C2.59333 2.33337 2 2.92671 2 3.66671V6.33337H3.33333V3.66671H12.6667V13H3.33333V10.3334H2V13C2 13.3537 2.14048 13.6928 2.39052 13.9429C2.64057 14.1929 2.97971 14.3334 3.33333 14.3334H12.6667C13.0203 14.3334 13.3594 14.1929 13.6095 13.9429C13.8595 13.6928 14 13.3537 14 13V3.66671C14 2.92671 13.4 2.33337 12.6667 2.33337ZM6.72 10.72L7.66667 11.6667L11 8.33337L7.66667 5.00004L6.72 5.94004L8.44667 7.66671H2V9.00004H8.44667L6.72 10.72Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderSignInViewLogOut);
export default __webpack_public_path__ + "static/media/HeaderSignInViewLogOut.b526f2aa27ef92cc51666b20e4610fd6.svg";
export { ForwardRef as ReactComponent };